




















import { Component, Mixins } from "vue-property-decorator";
import ReferralCode from "basis/components/invite/ReferralCode.vue";
import Inviter from "basis/components/invite/Inviter.vue";
import Invitee from "basis/components/invite/Invitee.vue";
import mixins from "@/mixins";

@Component({
  components: {
    ReferralCode,
    Inviter,
    Invitee
  }
})
class Invite extends Mixins(mixins.page) {
  needMigrate = true;

  get title() {
    return this.$t("common.invite") as string;
  }
}
export default Invite;
